export const CLERK_TOKEN_TEMPLATE = "__token";
